document.addEventListener("DOMContentLoaded", function() {
  var stickyReminder = document.getElementById("sticky-reminder");
  var popup = document.querySelector('.popup-modal');
  
   if (localStorage.getItem('stickyReminderClosed') === 'true') {
      
      document.getElementById('sticky-reminder').style.display = 'none';
    } else {
      // Show the modal
      
      //document.getElementById('sticky-reminder').style.display = 'block';
    }

    document.getElementById('close-sticky').addEventListener('click', function () {
      document.getElementById('sticky-reminder').style.display = 'none';
      // Set the flag in localStorage to not show the modal again
      localStorage.setItem('stickyReminderClosed', 'true');
    });


    document.getElementById('close-sticky').addEventListener('click', function (event) {
        event.stopPropagation(); // Prevent the stickyReminder click event
        document.getElementById('sticky-reminder').style.display = 'none';
        // Set the flag in localStorage to not show the modal again
        localStorage.setItem('stickyReminderClosed', 'true');
    });
  
    setTimeout(function() {
      // console.log('Sticky Reminder:', stickyReminder);
      // console.log('Popup:', popup);
       checkPopupStatus();
  
      // Ensure both elements exist before proceeding
      if (stickyReminder && popup) {
        stickyReminder.addEventListener('click', function() {
          popup.setAttribute('open', 'true');
          popup.classList.add('is-visible');
           checkPopupStatus();
        });
      } else {
        console.error("Popup or sticky reminder not found");
      } 
    }, 3000); // Adjust the delay as needed (5000 ms = 5 seconds)
  
    popup.addEventListener('click', function() {
        setTimeout(function() {
        checkPopupStatus(); // Re-check the popup status when clicked
        }, 3000);
        
    });
  
    function checkPopupStatus() {
    if (popup.hasAttribute('open')) {
      stickyReminder.style.display = "none";
    } else {
      if (localStorage.getItem('stickyReminderClosed') === 'true') {
        stickyReminder.style.display = "none";
      } else {
        stickyReminder.style.display = "block";
      }
    }
  }
});
